export default {
    camelCase(input) {
        // based on http://stackoverflow.com/a/10425344/229189
        return input
            .toLowerCase()
            .replace(
                /-(.)/g,
                function (match, group_1) {
                    return group_1.toUpperCase();
                }
            );
    },
    getTransitionDuration(element, with_delay) {
        // based on http://stackoverflow.com/a/13008597
        var prefixes = ' webkit moz ms o khtml'.split( ' ' );
        var result = 0;
        var duration, delay, prefix;
        for (var i = 0; i < prefixes.length; i++) {
            prefix = prefixes[i] + '-';
            if ( prefixes[i] === '' ) {
                prefix = '';
            }
            duration = element.style[ this.camelCase(prefix + 'transition-duration') ];
            if ( duration ) {
                duration = (duration.indexOf('ms') >- 1) ? parseFloat(duration) : parseFloat(duration) * 1000;
                if (with_delay) {
                    delay = element.style[ this.camelCase(prefix + 'transition-delay') ];
                    if (delay) {
                        duration += (delay.indexOf('ms') >- 1) ? parseFloat(delay) : parseFloat(delay) * 1000;
                    }
                }
                result = duration;
                break;
            }
        }
        return result;
    },
    init() {
        // JavaScript to be fired on all pages
        var self = this;
        var dom = {
            window: $(window),
            html: $('html'),
            body: $('body'),
        };
        var scroll = {
            getScrollY: function() {
                return window.scrollY;
            },
            init: function() {
                scroll.lastY = scroll.getScrollY();
                scroll.isSuppress = false;
                dom.window.on("scroll", scroll.handleScrolling);
            },
            suppress: function( boolean ) {
                scroll.isSuppress = boolean;
            },
            handleScrolling: function( event ) {
                if (menu.isSuppress) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
                var currY = scroll.getScrollY();
                var direction = (currY > scroll.lastY) ? "scrolldown" : ((currY === scroll.lastY) ? undefined : "scrollup");
                if (direction !== undefined) {
                    dom.window.triggerHandler( direction );
                }
                scroll.lastY = currY;
            },
        };
        var header = {
            init: function() {
                header.threshold = 500;
                header.$nav = $(".js-header");
                header.isTipinAble = false;
                header.isLeftBehind = false,
                dom.window.on("scroll", header.headScroll);
                dom.window.on("scrollup", header.headUp);
                dom.window.on("scrolldown", header.headDown);
            },
            headUp: function( event ) {
                var top = scroll.getScrollY();
                if (header.isLeftBehind && top >= header.threshold) {
                    header.isTipinAble = true;
                    header.$nav.setPosition(0, 0);
                }
            },
            headScroll: function( event ) {
                var top = scroll.getScrollY();
                var size = header.$nav.getSize();
                var height = 2 * size.height;
                var middle = top / 2;
                if (top <= 0 && header.isTipinAble) {
                    header.isTipinAble = false;
                    header.$nav.removeClass("is-tipinable").addClass("is-toppable");
                }
                if (top <= height && !header.isTipinAble) {
                    if (header.isLeftBehind) {
                        header.isLeftBehind = false;
                    }
                    header.$nav.removeClass("is-tipinable");
                    header.$nav.setPosition(0, -middle);
                } else {
                    if (top > height && !header.isLeftBehind) {
                        header.isLeftBehind = true;
                        header.$nav.addClass("is-tipinable").removeClass("is-toppable");
                        header.$nav.setPosition(0, -size.height);
                    }
                }
            },
            headDown: function( event ) {
                var top = scroll.getScrollY();
                var size = header.$nav.getSize();
                if (header.isLeftBehind && top >= header.threshold) {
                    header.isTipinAble = false;
                    header.$nav.setPosition(0, -size.height);
                }
            },
        };
        var menu = {
            init: function() {
                menu.isOpen = false;
                menu.isDisabled = false;
                menu.$node = $(".js-menu-nav");
                menu.tDuration = self.getTransitionDuration(menu.$node[0]);
                menu.scrollPos = scroll.getScrollY();
                header.$nav.on("click", ".js-controller--nav", menu.handleOpen);
            },
            handleOpen: function( event ) {
                if (!menu.isActive()) {
                    menu.open();
                    menu.$node.on("click", menu.handleClose);
                }
            },
            handleClose: function( event ) {
                if (menu.isActive()) {
                    menu.close();
                    menu.$node.off("click", menu.handleClose);
                }
            },
            disableHeader: function( boolean ) {
                menu.isDisabled = boolean;
            },
            open: function() {
                menu.isOpen = true;
                dom.html.addClass("is-menu-open");
                menu.disableHeader(true),
                menu.scrollPos = scroll.getScrollY();
                scroll.suppress(true);
                menu.$node.attr("tabindex", "-1"),
                setTimeout(function() {
                    return menu.$node.addClass("is-active");
                }, 0);
                setTimeout(function() {
                    menu.$node.addClass("is-active-events");
                    dom.html.addClass("is-clipped");
                    dom.body.addClass("is-clipped")
                }, 2 * menu.tDuration);
            },
            close: function() {
                menu.isOpen = false;
                menu.$node.removeClass("is-active");
                dom.html.removeClass("is-clipped");
                dom.body.removeClass("is-clipped");
                dom.body[0].scrollTop = menu.scrollPos;
                scroll.suppress(false);
                this.$node.removeAttr("tabindex");
                setTimeout(function() {
                    menu.disableHeader(false);
                    dom.html.removeClass("is-menu-open");
                    menu.$node.removeClass("is-active-events");
                }, 2 * menu.tDuration);
            },
            toggle: function() {
                if (menu.isOpen) {
                    menu.close();
                } else {
                    menu.open()
                }
            },
            isActive: function() {
                return menu.isOpen;
            },
        };
        scroll.init();
        header.init();
        menu.init();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js